export const FIELDS = {
  face_shape: {
    key: "face_shape",
    label: "Face shape",
    title: "Face shape",
    options: [
      { v: "oval", l: "Oval" },
      { v: "round", l: "Round" },
      { v: "square", l: "Square" },
      { v: "oblong", l: "Rectangle/Oblong" },
      { v: "heart", l: "Heart" },
      { v: "diamond", l: "Diamond" },
      { v: "triangle", l: "Triangle" },
    ],
  },
  hair_pattern: {
    key: "hair_pattern",
    label: "Hair pattern",
    title: "Hair pattern",
    options: ["1A", "1B", "1C", "2A", "2B", "2C", "3A", "3B", "3C", "4A", "4B", "4C"].map((v) => ({ v, l: v })),
    help: "1 = straight · 2 = wavy · 3 = curly · 4 = coily",
  },
  length: {
    key: "length",
    label: "Length",
    title: "How long is your hair right now?",
    options: [
      { v: "buzz", l: "Buzzed" },
      { v: "short", l: "Short" },
      { v: "medium", l: "Medium" },
      { v: "long", l: "Long" },
    ],
  },
  hair_type: {
    key: "hair_type",
    label: "Hair type",
    title: "What's your hair type?",
    options: [
      { v: "straight", l: "Straight" },
      { v: "wavy", l: "Wavy" },
      { v: "curly", l: "Curly" },
      { v: "coily", l: "Coily" },
    ],
  },
  thickness: {
    key: "thickness",
    label: "Thickness",
    title: "How thick are your strands?",
    help: "Roll one strand between your fingers. Barely feel it = fine. Feels like thread = coarse.",
    options: [
      { v: "fine", l: "Fine" },
      { v: "medium", l: "Medium" },
      { v: "coarse", l: "Coarse" },
    ],
  },
  density: {
    key: "density",
    label: "Density",
    title: "Density",
    options: [
      { v: "low", l: "Low" },
      { v: "medium", l: "Medium" },
      { v: "high", l: "High" },
    ],
  },
  preferred_style: {
    key: "preferred_style",
    label: "Style preference",
    title: "What kind of style are you into?",
    options: [
      { v: "short-neat", l: "Short & neat" },
      { v: "textured", l: "Textured" },
      { v: "flow", l: "Longer flow" },
      { v: "curly-natural", l: "Natural curls" },
      { v: "classic", l: "Classic" },
      { v: "fade", l: "Fades" },
      { v: "trending", l: "Trending" },
    ],
  },
  hold: {
    key: "hold",
    label: "Hold",
    title: "How much hold do you want?",
    options: [
      { v: "light", l: "Light" },
      { v: "medium", l: "Medium" },
      { v: "strong", l: "Strong" },
    ],
  },
  finish: {
    key: "finish",
    label: "Finish",
    title: "What finish do you prefer?",
    options: [
      { v: "natural", l: "Natural" },
      { v: "matte", l: "Matte" },
    ],
  },
  styling_time: {
    key: "styling_time",
    label: "Styling time",
    title: "How long do you spend styling each day?",
    options: [
      { v: "under-5", l: "Under 5 min" },
      { v: "5-10", l: "5–10 min" },
      { v: "10-plus", l: "10+ min" },
    ],
  },
  concerns: {
    key: "concerns",
    label: "Hair concerns",
    title: "Any main hair concerns?",
    multi: true,
    help: "Pick as many as you like.",
    options: [
      { v: "frizz", l: "Frizz" },
      { v: "dryness", l: "Dryness" },
      { v: "tangles", l: "Tangles" },
      { v: "flat", l: "Flat / no volume" },
      { v: "unruly", l: "Hard to control" },
      { v: "low-maintenance", l: "Want low effort" },
    ],
  },
  experience: {
    key: "experience",
    label: "Experience",
    title: "How experienced are you with styling?",
    options: [
      { v: "beginner", l: "Beginner" },
      { v: "intermediate", l: "Intermediate" },
      { v: "advanced", l: "Advanced" },
    ],
  },
};

export const QUESTIONNAIRE = ["length", "hair_type", "thickness", "preferred_style", "hold", "finish", "styling_time", "concerns", "experience"];

export const PROFILE_FIELDS = ["face_shape", "hair_pattern", "hair_type", "length", "density", "thickness", "preferred_style", "finish", "hold", "styling_time", "concerns", "experience"];

export function labelFor(key, value) {
  if (value == null || (Array.isArray(value) && value.length === 0) || value === "") return "—";
  const f = FIELDS[key];
  const one = (v) => f?.options.find((o) => o.v === v)?.l ?? v;
  return Array.isArray(value) ? value.map(one).join(", ") : one(value);
}

export function typeFromPattern(pattern) {
  if (!pattern) return null;
  return { 1: "straight", 2: "wavy", 3: "curly", 4: "coily" }[pattern[0]] ?? null;
}

export function titleCase(s) {
  if (!s) return "";
  return s.charAt(0).toUpperCase() + s.slice(1).replace(/-/g, " ");
}
